// Copyright (c) Facebook, Inc. and its affiliates.
import React from 'react';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { withStyles } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import CustomDivider from './CustomDivider';

const styles = theme => ({
    gridItem: {
        padding: theme.spacing.unit * 1.5
    },
    sectionHeader: {
        marginTop: '0.2em',
        fontSize: '2.5g rem'
    },
    primaryColor: {
        color: theme.palette.primary.main
    },
    description: {
        color: '#6c757d',
    }
});

class DatasetFeature extends React.Component {
    render() {

        const { classes } = this.props;

        return (
            <Grid
                container
                justify="center"
                alignItems="center"
                spacing={16}
            >
                <Grid item xs={12} className={classes.gridItem}>
                    <Typography
                        className={classes.sectionHeader}
                        variant="h4"
                        align="center"
                    >
                        Introducing LVIS
                    </Typography>
                    <CustomDivider />
                </Grid>

                <Grid item xs={12} sm={4}>
                    <Grid container justify="center" alignItems="center">
                        <Grid item xs={12} className={classes.gridItem}>
                            <FontAwesomeIcon
                                className={classes.primaryColor}
                                icon="shapes"
                                size='4x'
                            />
                        </Grid>
                        <Grid item xs={12} className={classes.gridItem}>
                            <Typography
                                variant="h5"
                                align="center"
                            >
                                1200+ Categories
                            </Typography>
                        </Grid>
                        <Grid item xs={12} className={classes.gridItem}>
                            <Typography
                                className={classes.description}
                                variant="subtitle1"
                                align="center"
                                >
                                Found by data-driven object discovery in 164k images.
                            </Typography>
                        </Grid>
                    </Grid>
                </Grid>

                <Grid item xs={12} sm={4} className={classes.gridItem}>
                    <Grid item xs={12} className={classes.gridItem}>
                        <FontAwesomeIcon
                            className={classes.primaryColor}
                            icon="chart-bar"
                            size='4x'
                        />
                    </Grid>
                    <Grid item xs={12} className={classes.gridItem}>
                        <Typography
                            variant="h5"
                            align="center"
                            >
                            Long Tail
                        </Typography>
                    </Grid>
                    <Grid item xs={12} className={classes.gridItem}>
                        <Typography
                            className={classes.description}
                            variant="subtitle1"
                            align="center"
                            >
                            Category discovery naturally reveals a large number of rare categories.
                        </Typography>
                    </Grid>
                </Grid>

                <Grid item xs={12} sm={4} className={classes.gridItem}>
                    <Grid item xs={12} className={classes.gridItem}>
                        <FontAwesomeIcon
                            className={classes.primaryColor}
                            icon="draw-polygon"
                            size='4x'
                        />
                    </Grid>
                    <Grid item xs={12} className={classes.gridItem}>
                        <Typography
                            variant="h5"
                            align="center"
                            >
                            Masks
                        </Typography>
                    </Grid>
                    <Grid item xs={12} className={classes.gridItem}>
                        <Typography
                            className={classes.description}
                            variant="subtitle1"
                            align="center"
                            >
                            More than 2 million high quality instance segmentation masks.
                        </Typography>
                    </Grid>
                </Grid>

            </Grid>
        )
    }

}

export default withStyles(styles)(DatasetFeature);
